import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import {
  ChakraProvider,
  Box,
  Heading,
  Stepper,
  Step,
  StepIndicator,
  StepStatus,
  StepTitle,
  StepDescription,
  StepSeparator,
  useSteps,
  useToast,
  Text,
  Button,
  Flex,
} from '@chakra-ui/react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import axios from 'axios';
import { formData } from './exitIntentFormData';
import TemplateSelection from './TemplateSelection';
import DesignEditor from './DesignEditor';
import ConfigurationEditor from './ConfigurationEditor';
import ExitIntentModal from './ExitIntentPreviewModal';
import MKTEXITINTENTTEMP1 from './templates/MKTEXITINTENTTEMP1';
import MKTEXITINTENTTEMP2 from './templates/MKTEXITINTENTTEMP2';
import { ExitIntentTemplates } from './exitIntentTemplatesData';
import axiosInstance from '../../Services/axiosInstance';
import MKTEXITINTENTTEMP3 from './templates/MKTEXITINTENTTEMP3';
import MKTEXITINTENTTEMP4 from './templates/MKTEXITINTENTTEMP4';
import MKTEXITINTENTTEMP31 from './templates/MKTEXITINTENTTEMP31';

const ExitIntent1 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [markup, setMarkup] = useState("")
  
  const { uuid }= useParams()

  const steps = [
    { title: 'Select Overlay', description: 'Choose a template' },
    { title: 'Edit Design', description: 'Customize the design' },
    { title: 'Configure', description: 'Set up options' },
  ];

  const { activeStep, setActiveStep } = useSteps({
    index: 1,
    count: steps.length,
  });

  
  const getMarkup = () => {
    
    let templateMarkup = document.getElementsByClassName(formik.values.actionProps?.emailSubscriptionForm?.cssTemplateId)[0]?.innerHTML;
    setMarkup(templateMarkup.trim());
  }

  const formik = useFormik({
    initialValues: formData,
    enableReinitialize:true,
    onSubmit: async (values) => {
      try {
         
         let data  = {...values, markup : markup }
        if (uuid) {
          await axiosInstance.put(`/exitintent/campaigns/${uuid}`, data);
          toast({ title: 'Success', description: 'Campaign updated successfully', status: 'success', duration: 3000 });
        } else {
          await axiosInstance.post('/exitintent/campaigns', data);
          toast({ title: 'Success', description: 'Campaign created successfully', status: 'success', duration: 3000 });
        }
        navigate('/exit-intent-list');
      } catch (error) {
        toast({ title: 'Error', description: 'Failed to save campaign', status: 'error', duration: 3000 });
      }
    },
  });

  useEffect(() => {
    if (uuid) {
      
      const fetchCampaign = async () => {
        try {
          const response = await axiosInstance.get(`/exitintent/campaigns/${uuid}`);
          formik.setValues(response.data);
          setActiveStep(2);
        } catch (error) {
          console.error('Error fetching campaign:', error);
        }
      };
      fetchCampaign();
    }
  }, [uuid, setActiveStep]);
  const handleTemplateSelect = (templateId) => {
    
    const newTemplateData = {
      ...ExitIntentTemplates[templateId],
      cssTemplateId: templateId
    };
    
    
    console.log('New template data:', newTemplateData);
    
    formik.setFieldValue('actionProps.emailSubscriptionForm', newTemplateData)
      .then((res) => {
        
        console.log('Updated formik values:', formik.values);
        setActiveStep(2);
      })
      .catch((error) => {
        console.error('Error setting formik values:', error);
      });
  };
  useEffect(() => {
    // handleOverlyPosition();
    // handleFullScreenTemplates()
    
  }, [activeStep]);

  let obj = {
    MKTEXITINTENTTEMP1: <MKTEXITINTENTTEMP1  formData={formik.values} />,
    MKTEXITINTENTTEMP2: <MKTEXITINTENTTEMP2 formData={formik.values} />,
    MKTEXITINTENTTEMP3: <MKTEXITINTENTTEMP3 formData={formik.values} />,
    MKTEXITINTENTTEMP4: <MKTEXITINTENTTEMP4 formData={formik.values} />,
    // MKTEXITINTENTTEMP31: <MKTEXITINTENTTEMP31 formData={formik.values} />
  };

  const handleNext = () => {
    if (activeStep < steps.length) {
      setActiveStep(activeStep + 1);
    }
  };

  const handleBack = () => {
    if (activeStep > 1) {
      setActiveStep(activeStep - 1);
    }
  };

  return (
    <ChakraProvider>
      <Box p={6} display="flex">
        <Box flex="1">
          <Stepper index={activeStep - 1} orientation="horizontal" mb={6}>
            {steps.map((step, index) => (
              <Step key={index} onClick={() => setActiveStep(index + 1)}>
                <StepIndicator>
                  <StepStatus
                    complete={<Box>✅</Box>}
                    incomplete={<Box>{index + 1}</Box>}
                    active={<Box>⏳</Box>}
                  />
                </StepIndicator>
                <Box flexShrink="0">
                  <StepTitle>{step.title}</StepTitle>
                  <StepDescription>{step.description}</StepDescription>
                </Box>
                <StepSeparator />
              </Step>
            ))}
          </Stepper>

          {/* Step 1: Template Selection */}
          {activeStep === 1 && (
            <Box>
              <TemplateSelection onTemplateSelect={handleTemplateSelect} />
              {/* <Flex justify="space-between" mt={4}>
                <Button onClick={handleBack} isDisabled={activeStep === 1} colorScheme="gray">
                  Back
                </Button>
                <Button onClick={handleNext} colorScheme="blue" isDisabled={!formik.values?.actionProps?.emailSubscriptionForm?.cssTemplateId}>
                  Next
                </Button>
              </Flex> */}
            </Box>
          )}

          {/* Step 2: Design Editor */}
          {activeStep === 2 && (
            <>
            <Box width={'100%'} justifyContent={'space-between'} display={'flex'} >
              <DesignEditor formik={formik} setActiveStep={setActiveStep} navigate={navigate} />
              <Box
            id="previewPane"
            className="preview-pane"
            style={{ height: '72vh', background: '#212121bd', padding: 0, width: '600px' }}
            >
            <Box className="mkt-panel-preview-frame">
              {obj[formik.values?.actionProps?.emailSubscriptionForm?.cssTemplateId]}
            </Box>

          </Box>

            </Box>
              <Flex justify="space-between" mt={4}>
                <Button onClick={handleBack} colorScheme="gray">
                  Back
                </Button>
                <Button onClick={()=>{handleNext();getMarkup()}} colorScheme="blue">
                  Next
                </Button>
              </Flex>
            </>
          )}

          {/* Step 3: Configuration Editor */}
          {activeStep === 3 && (
            <Box>
              <ConfigurationEditor formik={formik} />
              <Flex justify="space-between" mt={4}>
                <Button onClick={handleBack} colorScheme="gray">
                  Back
                </Button>
                <Button onClick={formik.handleSubmit} colorScheme="green">
                  Save
                </Button>
              </Flex>
            </Box>
          )}
        </Box>

      </Box>
    </ChakraProvider>
  );
};

export default ExitIntent1;